import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {UserType} from '../model/user-type.model';
import {ApiService} from './api.service';

@Injectable({providedIn: 'root'})
export class UserTypeService {

  private types: UserType[] = [];

  constructor(private apiService: ApiService) {
    new Observable<UserType[]>(subscriber => {
      this.apiService.send({
        command: 'user_type',
        request: {}
      }, (response) => {
        let types: UserType[] = [];

        response = response.response;
        if (!response.error && Array.isArray(response)) {
          for (const type of response) {
            types.push({
              id: type.id,
              name: type.name,
              system: type.system
            })
          }
          subscriber.next(types);
        }
      });
    }).subscribe((types) => {
      this.types = types;
    });
  }

  getTypes(system?: boolean) {
    return this.types.filter(n => system === undefined || n.system === system);
  }

  getName(typeId) {
    for (const type of this.getTypes()) {
      if (type.id === typeId) {
        return type.name;
      }
    }
    return typeId;
  }
}
